var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('notifications'),_c('side-bar',{scopedSlots:_vm._u([{key:"links",fn:function(){return [(_vm.role == 2 || _vm.role == 3)?_c('sidebar-item',{attrs:{"link":{
        name: 'PEGAWAI BGE',
        path: '',
        icon: 'ni ni-collection text-success'
      }}},[_c('sidebar-item',{attrs:{"link":{
          name: 'DAFTAR PROFIL PEGAWAI',
          path: '/DaftarKiraanPSM',
          icon: 'ni ni-single-02 text-secondary'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'DASHBOARD',
          path: '/dashboardSkg',
          //path: '/DashboardPSMBGE',
          icon: 'ni ni-single-02 text-secondary'
        }}})],1):_vm._e(),(_vm.role == 4)?_c('sidebar-item',{attrs:{"link":{
        name: 'PEGAWAI PSM',
        path: '',
        icon: 'ni ni-collection text-success'
      }}},[_c('sidebar-item',{attrs:{"link":{
          name: 'DAFTAR PROFIL PEGAWAI',
          path: '/DaftarKiraanPSM',
          icon: 'ni ni-single-02 text-secondary'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'DASHBOARD',
          path: '/dashboardSkg',
          //path: '/DashboardPSMBGE',
          icon: 'ni ni-single-02 text-secondary'
        }}})],1):_vm._e(),(_vm.role == 3)?_c('sidebar-item',{attrs:{"link":{
        name: 'SELENGGARA PENGGUNA',
        path: '/selenggaraPengguna',
        icon: 'ni ni-settings-gear-65 text-warning'
      }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
        name: 'BORANG',
        path: '',
        icon: 'ni ni-collection text-success'
      }}},[_c('sidebar-item',{attrs:{"link":{
    name: ' JADUAL GAJI KHAS UNTUK PENYANDANG',
    path: '#',   // dummy path supaya item muncul
    icon: 'ni ni-cloud-download-95 text-info'
  }},nativeOn:{"click":function($event){$event.preventDefault();return _vm.downloadManual($event)}}})],1),_c('sidebar-item',{attrs:{"link":{
    name: ' MANUAL PENGGUNA',
    path: '#',   // dummy path supaya item muncul
    icon: 'ni ni-cloud-download-95 text-info'
  }}})]},proxy:true}])}),_c('div',{staticClass:"main-content"},[_c('dashboard-navbar',{attrs:{"type":_vm.$route.meta.navbarType}}),_c('div',{on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }